// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__ksOm9","errors":"Errors_errors__FE6Nm"};